import { analytics_methods } from "../../utils/analytics_methods";
import addKeysToSchema from "./schema";
import getItemstData from "../../utils/items_checkout";

function triggerEvent () {

    const schema = addKeysToSchema({
        time_selected: "string",
        date_selected: "string",
        ticket_category: "string",
    });

    const data = {
        event: "add_payment_info",
        event_type: "cta_click",
        ecommerce: {
            value: window?.analytics_buendia?.total_value_with_commission ?? null,
            currency: window?.analytics_buendia?.currency || null,
            payment_type: "tarjeta", // set by default for now as this is the only accepted payment method,, and cannot be grabbed from the cms, in the future will be changed for a dynamic value
            items: getItemstData()
        }
    }

    analytics_methods.sendToDataLayer(data, schema);

} 


export const add_payment_info_event = {
    triggerEvent
}